<template>
  <div>
    <div class="el-row--flex" v-for="(timeRange, index) in tRanges" :key="index">
      <el-time-select
        class="start-time"
        placeholder="起始时间"
        v-model="timeRange.startTime"
        :picker-options="{
          start: '00:00',
          step: optionsStep,
          end: optionsEnd,
          ...limitTime(timeRange, index, 'startTime')
        }"
        :clearable="false"
        :editable="editable"
        @change="change">
      </el-time-select>
      <span>-</span>
      <el-time-select
        class="end-time"
        placeholder="结束时间"
        v-model="timeRange.endTime"
        :picker-options="{
          start: '00:00',
          step: optionsStep,
          end: optionsEnd,
          ...limitTime(timeRange, index, 'endTime')
        }"
        :clearable="false"
        :editable="editable"
        @change="change">
      </el-time-select>
      <el-button class="delete-btn" type="danger" icon="el-icon-minus" circle @click="deleteRange(index)"></el-button>
    </div>
    <template v-if="showAddBtn">
      <el-button class="add-btn" type="primary" icon="el-icon-plus" @click="appendOne">添加</el-button>
    </template>
  </div>
</template>

<script>
  export default {
    name: "mulTimePicker",
    props: {
      value: '', // 时间范围
      type: '', // 不同默认值类型 last const
      defaultValue: '00:00',
      rangeSeparator: ' ', // 时间范围的分隔符
      limit: {
        type: Number,
        default: 4
      }, // 限制时间段的最大个数
      showAddBtn: {
        type: Boolean,
        default: true
      }, // 是否显示添加按钮
      editable: {
        type: Boolean,
        default: true
      }, // 是否可文本框输入
      step: {
        type: Number,
        default: 15
      }
    },
    data() {
      return {
        tRanges: [],
      }
    },
    created() {
      this.tRanges = this.formatIn(this.value)
    },
    methods: {
      nextTime(thisTime) {
        // 数据形如：'00:45'
        if(!thisTime || thisTime === '') return
        let ht = Number(thisTime.split(':')[0])
        let mt = Number(thisTime.split(':')[1])
        ht = (mt + this.step) >= 60 ? ht+1 : ht
        if(ht === 24) throw 'time out of bounds'
        mt = (mt + this.step)%60
        return this.pad(ht, 2) + ':' + this.pad(mt, 2)
      },
      /* 质朴长存法 by lifesinger */
      pad(num, n) {
        let len = num.toString().length;
        while(len < n) {
          num = "0" + num;
          len++;
        }
        return num;
      },
      formatIn(val1) {
        if(!val1 || val1 === '') return []
        let val2 = []
        let obj = {}
        val1.split(',').forEach((item, i) =>{
          obj = {
            startTime: item.split('-')[0],
            endTime: item.split('-')[1]
          }
          val2.push(obj)
        })
        console.log(val2)
        return val2
      },
      formatOut(val1) {
        if(!val1 || val1.length === 0) return ''
        let val2 = [],
          str = ''
        val1.forEach((item, i) => {
          str = item.startTime + '-' + item.endTime
          val2.push(str)
        })
        return val2.join(',')
      },
      appendOne() {
        console.log("appendOne")
        if(this.tRanges.length < this.limit) {
          let obj = {
            startTime: '00:00',
            endTime: this.optionsEnd
          }
          if(this.tRanges.length > 0) {
            try {
              obj.startTime = this.nextTime(this.tRanges[this.tRanges.length-1].endTime)
            }catch (e) {
              console.log(e)
              return
            }
          }
          this.tRanges.push(obj)
        }
        this.change()
      },
      deleteRange(index) {
        this.tRanges.splice(index,1)
        this.change()
      },
      change() {
        // console.log(this.tRanges)
        this.$emit("input", this.formatOut(this.tRanges))
        this.$emit('change', this.formatOut(this.tRanges))
      },
    },
    watch: {
      value(val) {
        this.tRanges = this.formatIn(val)
      },
      tRanges(val) {
        // console.log(val)
        // this.$emit("input", this.formatOut(this.tRanges))
      }
    },
    computed: {
      limitTime() {
        return (timeRange, index, type) => {
          let startTime = '',
            endTime = '23:59'
          if(type === 'startTime') {
            endTime = timeRange.endTime
            if(index > 0) { // 从第二项开始 开始时间为上一项的结束时间
              startTime = this.tRanges[index-1].endTime
            }
          }else {
            startTime = timeRange.startTime
            if(index < this.tRanges.length -1) { // 除了最后一项 结束时间为下一项的开始时间
              endTime = this.tRanges[index+1].startTime
            }
          }
          return {
            minTime: startTime,
            maxTime: endTime
          }
        }
      },
      optionsStep() {
        let ht = this.step/60
        let mt = this.step%60
        return this.pad(ht, 2) + ':' + this.pad(mt, 2)
      },
      optionsEnd() {
        let ht = Math.floor((24*60 - this.step)/60)
        let mt = (24*60 - this.step)%60
        console.log(ht)
        return this.pad(ht, 2) + ':' + this.pad(mt, 2)
      },
      // selectableRange() { // 限制开始和结束时间范围
      //   return (timeRange, index, type) => {
      //     let startTime = '00:00:00',
      //       endTime = '23:59:59'
      //     if(type === 'startTime') {
      //       endTime = timeRange.endTime
      //       if(index > 0) { // 从第二项开始 开始时间为上一项的结束时间
      //         startTime = this.tRanges[index-1].endTime
      //       }
      //     }else {
      //       startTime = timeRange.startTime
      //       if(index < this.tRanges.length -1) { // 除了最后一项 结束时间为下一项的开始时间
      //         endTime = this.tRanges[index+1].startTime
      //       }
      //     }
      //     return startTime + ' - ' + endTime
      //   }
      // }
    }
  }
</script>

<style lang="less" scoped>
  .start-time {
    margin: 0 8px 10px 0;
  }
  .end-time {
    margin: 0 10px 10px 8px;
  }
  .delete-btn{
    margin-top: 8px;
    width: 24px;
    padding: 2px 0 0 0;
    font-size: 16px;
    height: 24px;
  }
  .add-btn{

  }
</style>



// WEBPACK FOOTER //
// src/components/mulTimePicker.vue